import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/termine/bg_termine.png";


const Termine = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Terminvereinbarung </h1>
                    <p className="grey-text">
                        <h4> Erstbesuch </h4>
                        Wir bitten Sie, dieses Datenblatt bereits ausgefüllt zur Untersuchung mitzubringen: <a onClick={() => {window.open('/pdfs/Patienten_DATENBLATT.pdf', '_blank');}}> Datenblatt </a>
                        <h4> Wartezeiten </h4>
                        Werte Patientinnen und Patienten, es ist mir ein besonderes Anliegen, die Wartezeiten zu verkürzen. Vereinbaren Sie immer einen Termin (auch wenn Sie nur "kurz" etwas besprechen wollen, bzw. Sie akut ein Problem haben) - ein Anruf, damit wir Bescheid wissen, dass Sie kommen!
                        <br/><br/>Aus organisatorischen Gründen öffnet die Ordination 15 Minuten vor Beginn. Wir freuen uns über Pünktlichkeit, ein vorzeitiges Erscheinen verschiebt allerdings nicht den Zeitpunkt des eingetragenen Termines.
                        <h4> Vertretungsärzte </h4>
                        In Urlaubs- / Fortbildungszeiten werde ich von KollegInnen meines Vertrauens vertreten. Diese Zusammenarbeit ermöglicht Ihnen, zusätzliche Qualifikationen und vermehrte Öffnungszeiten wahrzunehmen.
                    </p>

                    <iframe id="eServiceIFrame" height="800" marginheight="0" src="https://home.cgm-life.de/eServices/?institution=ebcb7799-e73f-4bc9-abc1-74d867217e1a" frameborder="0" width="100%" name="eServices" marginwidth="0" align="left">                                   
                        <p>Ihr Browser kann leider keine eingebetteten Frames anzeigen: Sie k&oumlnnen die eingebettete Seite &uumlber den folgenden Verweis aufrufen: <a href="https://home.cgm-life.de/eServices/?institution=ebcb7799-e73f-4bc9-abc1-74d867217e1a" id="eServiceLink">eServices</a></p>
                    </iframe>

                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Termine;
